import moment from "moment";
import React, { useEffect, useState } from "react";
import { ImNewTab } from "react-icons/im";
import { LuArchiveRestore } from "react-icons/lu";
import { MdInfoOutline } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Spinner, UncontrolledDropdown } from "reactstrap";
import Swal from "sweetalert2";
import PlaceholderImg from "../../assets/placeholder-img.png";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  RSelect,
  Row,
} from "../../components/Component";
import ErrorComponent from "../../components/error/ErrorComponent";
import DotPagination from "../../components/pagination/DotPaginate";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  deleteCommunity,
  deleteCommunityPermanently,
  deleteMultipleCommunity,
  deleteMultipleCommunityPermanently,
  editCommunity,
  getCommunity,
  restoreCommunity,
  restoremultipleCommunity,
} from "../../redux/Apislices/communitySlice";
import { USDollar, getScreenWidth } from "../../utils/Utils";

const statusOptions = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "draft", label: "Draft" },
  { value: "on hold", label: "On Hold" },
];

const itemsPerPageOptions = [
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

const bulkActionOptions = [
  { value: "", label: "Bulk Action" },
  { value: "archive", label: "Archive" },
  { value: "delete", label: "Delete" },
];

const bulkRestoreOptions = [
  { value: "", label: "Bulk Action" },
  { value: "restore", label: "Restore" },
  { value: "delete", label: "Delete" },
];

const Community = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { community, permission } = useSelector((state) => ({
    community: state.community,
    permission: state?.auth?.profile?.permissions?.masterCommunity,
  }));

  const { communities: communityData } = community;

  const [selectedData, setSelectedData] = useState([]);
  const [screenWidth, setScreenWidth] = useState(getScreenWidth());
  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);

  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");

  const [limit, setLimit] = useState({ value: 25, label: "25" });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(25);

  const [sort, setSort] = useState("");
  const [status, setStatus] = useState("");
  const [assignmentStatus, setAssignmentStatus] = useState("");

  const [bulkAction, setBulkAction] = useState("");

  useEffect(() => {
    if (typeof limit === "object" && limit?.value) {
      setItemPerPage(limit?.value);
    } else {
      setItemPerPage(25);
    }
  }, [limit]);

  const handleGetData = async () => {
    dispatch(
      getCommunity({
        status: typeof status === "object" ? status?.value : status,
        page: currentPage,
        limit: itemPerPage,
        search: onSearchText,
        sort,
      })
    );
  };

  //debounce getDevelopmentList for search
  useEffect(() => {
    const timer = setTimeout(
      () => {
        dispatch(
          getCommunity({
            status: typeof status === "object" ? status?.value : status,
            page: currentPage,
            limit: itemPerPage,
            search: onSearchText,
            sort,
          })
        );
      },
      onSearchText ? 800 : 200
    );
    return () => clearTimeout(timer);
  }, [dispatch, currentPage, itemPerPage, onSearchText, sort, status, assignmentStatus]);

  // selects all the products
  const selectorCheck = (e) => {
    // add or remove all the items from development?.development?.data to selectedData
    if (e.currentTarget.checked) {
      setSelectedData(communityData?.data?.map((item) => item._id));
    } else {
      setSelectedData([]);
    }
  };

  // selects one product
  const onSelectChange = (e, id) => {
    // add or remove the selected item from selectedData
    if (e.currentTarget.checked) {
      setSelectedData([...selectedData, id]);
    } else {
      setSelectedData(selectedData.filter((item) => item !== id));
    }
  };

  // toggle search input
  const toggle = () => setonSearch(!onSearch);

  // bulk action change
  const onActionText = (e) => {
    setBulkAction(e);
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleActiveCommunity = (data) => {
    let toastId = toast.loading("Uppdating...");

    let payload = {
      ...data,
      type: data?.type,
    };

    if (data?.status === "active") {
      payload.status = "on hold";
    } else if (data?.status === "on hold" || data?.status === "pending") {
      payload.status = "active";
    }

    dispatch(
      editCommunity(
        data?._id,
        payload,
        (res) => {
          handleGetData();
          toast.dismiss(toastId);
          toast.success("Updated successfully.");
        },
        (res) => {
          toast.dismiss(toastId);
          toast.error(res?.message);
        }
      )
    );
  };

  const handleBulkAction = (e) => {
    if (bulkAction?.value === "archive") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Archive",
      }).then((result) => {
        if (result.isConfirmed) {
          handleArchiveMultiple(
            () => {
              Swal.fire("Archived!", "Selected Master Communities has been archived.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    } else if (bulkAction?.value === "delete") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDeleteMultiple(
            () => {
              Swal.fire("Deleted!", "Selected Master Communities has been deleted.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    } else if (bulkAction?.value === "restore") {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Restore",
      }).then((result) => {
        if (result.isConfirmed) {
          handleRestoreMultiple(
            () => {
              Swal.fire("Restored!", "Selected Master Communities has been restored.", "success");
            },
            () => {
              Swal.fire("Error!", "Something went wrong!", "error");
            }
          );
        }
      });
    }
  };

  const handleArchiveMultiple = async (successCB, errorCB) => {
    dispatch(
      deleteMultipleCommunity(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            handleGetData();
            setBulkAction("");
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleRestoreMultiple = async (successCB, errorCB) => {
    dispatch(
      restoremultipleCommunity(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            handleGetData();
            setBulkAction("");
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleDeleteMultiple = async (successCB, errorCB) => {
    dispatch(
      deleteMultipleCommunityPermanently(
        { ids: selectedData },
        (res) => {
          if (res?.success) {
            handleGetData();
            setBulkAction("");
            setSelectedData([]);
            successCB();
          }
        },
        (err) => {
          errorCB();
          toast.error(err?.message);
        }
      )
    );
  };

  const handleArchive = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Archive",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteCommunity(
            item?._id,
            (res) => {
              console.log("res: ", res);
              if (res?.success) {
                handleGetData();
              }
              Swal.fire("Archived!", "Master Community has been archived.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleRestore = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Restore",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          restoreCommunity(
            item?._id,
            (res) => {
              console.log("res: ", res);
              if (res?.success) {
                handleGetData();
              }
              Swal.fire("Archived!", "Master Community has been restored.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteCommunityPermanently(
            item?._id,
            (res) => {
              if (res?.success) {
                handleGetData();
              }
              Swal.fire("Deleted!", "Master Community has been deleted.", "success");
            },
            (err) => {
              Swal.fire("Error!", "Something went wrong!", "error");
              toast.error(err?.message);
            }
          )
        );
      }
    });
  };

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <React.Fragment>
      <Head title="Master Communities"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Master Community</BlockTitle>
              <BlockDes className="text-soft">
                {communityData?.data?.length && communityData?.success ? (
                  <p>You have total {communityData?.total?.total} master communities.</p>
                ) : null}
              </BlockDes>
            </BlockHeadContent>

            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>

                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button
                        className="toggle btn-icon d-md-none"
                        onClick={() => {
                          navigate("/master-community/add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus"></Icon>
                      </Button>

                      <Button
                        className="toggle d-none btn-outline-primary btn-dim d-md-inline-flex"
                        onClick={() => {
                          navigate("/master-community/add");
                        }}
                        disabled={permission && !permission?.add}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Master Community</span>
                      </Button>
                    </li>

                    {(typeof status === "object" && status?.value === "archive") || status === "archive" ? (
                      <li className="nk-block-tools-opt">
                        <Button
                          className="toggle btn-icon btn-outline-info d-md-none"
                          color="primary"
                          onClick={() => {
                            setStatus("");
                          }}
                        >
                          <Icon name="arrow-long-left"></Icon>
                        </Button>

                        <Button
                          className="toggle btn-outline-info btn-dim d-none d-md-inline-flex"
                          onClick={() => {
                            setStatus("");
                          }}
                        >
                          <Icon name="arrow-long-left"></Icon>
                          <span>All Master Communities</span>
                        </Button>
                      </li>
                    ) : (
                      <li className="nk-block-tools-opt">
                        <Button
                          className="toggle btn-icon d-md-none"
                          color="primary"
                          onClick={() => {
                            setStatus("archive");
                          }}
                        >
                          <Icon name="archive"></Icon>
                        </Button>

                        <Button
                          className="toggle btn-outline-danger btn-dim d-none d-md-inline-flex"
                          onClick={() => {
                            setStatus("archive");
                          }}
                        >
                          <Icon name="archive"></Icon>
                          <span>Archived</span>
                        </Button>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                {/* Bulk Actions */}
                {selectedData.length ? (
                  <div className="card-tools">
                    <div className="form-inline flex-nowrap gx-3">
                      <div className="form-wrap">
                        <RSelect
                          options={
                            (typeof status === "object" && status?.value === "archive") || status === "archive"
                              ? bulkRestoreOptions
                              : bulkActionOptions
                          }
                          className="w-130px"
                          placeholder="Bulk Action"
                          onChange={(e) => onActionText(e)}
                          value={bulkAction}
                        />
                      </div>
                      <div className="btn-wrap">
                        <span className="d-none d-md-block">
                          <Button
                            disabled={selectedData.length && bulkAction?.value ? false : true}
                            color="info"
                            outline
                            className="btn-dim"
                            onClick={(e) => {
                              if (selectedData.length && bulkAction?.value) {
                                handleBulkAction(e);
                              }
                            }}
                          >
                            Apply
                          </Button>
                        </span>
                        <span className="d-md-none">
                          <Button
                            color="info"
                            outline
                            disabled={selectedData.length && bulkAction?.value ? false : true}
                            className="btn-dim btn-icon"
                            onClick={(e) => {
                              if (selectedData.length && bulkAction?.value) {
                                handleBulkAction(e);
                              }
                            }}
                          >
                            <Icon name="arrow-right"></Icon>
                          </Button>
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}

                <div className="card-tools mr-n1">
                  <ul className="btn-toolbar gx-1">
                    {/* Search */}
                    <li>
                      <div
                        className="search-content"
                        style={{
                          border: "1px solid #dbdfea",
                          borderRadius: "4px",
                        }}
                      >
                        <Button
                          className="search-back btn-icon toggle-search active"
                          onClick={() => {
                            setSearchText("");
                            toggle();
                          }}
                        >
                          <Icon name="search"></Icon>
                        </Button>
                        <input
                          type="text"
                          className="border-transparent form-focus-none form-control"
                          placeholder="Search by name or address"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                        {onSearchText ? (
                          <Button
                            className="search-submit btn-icon"
                            onClick={() => {
                              setSearchText("");
                            }}
                          >
                            <Icon name="cross"></Icon>
                          </Button>
                        ) : null}
                      </div>
                    </li>

                    <li className="btn-toolbar-sep"></li>

                    <li>
                      <div className="toggle-wrap">
                        <Button
                          className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                          onClick={() => updateTableSm(true)}
                        >
                          <Icon name="menu-right"></Icon>
                        </Button>
                        <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                          <ul className="btn-toolbar gx-1">
                            <li className="toggle-close">
                              <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                <Icon name="arrow-left"></Icon>
                              </Button>
                            </li>

                            {/* Filter */}
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn dropdown-toggle" style={{ padding: "0" }}>
                                  <a href="#" className="btn btn-primary">
                                    <em className="icon ni ni-opt"></em>
                                    <span
                                      style={{
                                        padding: "0",
                                        margin: "0",
                                        paddingLeft: "5px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Filter
                                    </span>
                                  </a>
                                </DropdownToggle>
                                <DropdownMenu
                                  right
                                  className="filter-wg dropdown-menu-xl"
                                  style={{ overflow: "visible" }}
                                >
                                  <div className="dropdown-head">
                                    <span className="sub-title dropdown-title">Filter Master Communities</span>
                                  </div>
                                  <div className="dropdown-body dropdown-body-rg">
                                    <Row className="gx-6 gy-3">
                                      {/* <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id="hasBalance"
                                          />
                                          <label className="custom-control-label" htmlFor="hasBalance">
                                            {" "}
                                            Have Balance
                                          </label>
                                        </div>
                                      </Col>
                                      <Col size="6">
                                        <div className="custom-control custom-control-sm custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input form-control"
                                            id="hasKYC"
                                          />
                                          <label className="custom-control-label" htmlFor="hasKYC">
                                            {" "}
                                            KYC Verified
                                          </label>
                                        </div>
                                      </Col> */}

                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Status</label>
                                          <RSelect
                                            options={statusOptions}
                                            onChange={(value) => {
                                              setStatus(value);
                                            }}
                                            value={status}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>

                                      <Col size="6">
                                        <FormGroup>
                                          <label className="overline-title overline-title-alt">Items Per Page</label>
                                          <RSelect
                                            options={itemsPerPageOptions}
                                            onChange={(value) => {
                                              setLimit(value);
                                            }}
                                            value={limit}
                                            placeholder="Select"
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </div>

                                  <div className="dropdown-foot between">
                                    {/* <button type="button" className="btn btn-secondary">
                                      Filter
                                    </button> */}
                                    <span></span>

                                    <a
                                      href="#reset"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                        setStatus("");
                                        setAssignmentStatus("");
                                      }}
                                      className="clickable"
                                    >
                                      Reset Filter
                                    </a>
                                  </div>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>

                            {/* Sort */}
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle color="tranparent" className="btn btn-trigger btn-icon dropdown-toggle">
                                  <Icon name="sort-line"></Icon>
                                </DropdownToggle>
                                <DropdownMenu right>
                                  <ul className="link-list-opt no-bdr">
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("recently-updated");
                                        }}
                                        className={sort === "recently-updated" ? "text text-primary" : ""}
                                      >
                                        <span>Recently Updated</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("recently-added");
                                        }}
                                        className={sort === "recently-added" ? "text text-primary" : ""}
                                      >
                                        <span>Recently Added</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("oldest");
                                        }}
                                        className={sort === "oldest" ? "text text-primary" : ""}
                                      >
                                        <span>Oldest First</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("asc");
                                        }}
                                        className={sort === "asc" ? "text text-primary" : ""}
                                      >
                                        <span>0-9, A-Z</span>
                                      </DropdownItem>
                                    </li>
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setSort("desc");
                                        }}
                                        className={sort === "desc" ? "text text-primary" : ""}
                                      >
                                        <span>9-0, Z-A</span>
                                      </DropdownItem>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className={`card-search search-wrap `}>
                <div className="card-body">
                  <div className="search-content">
                    <Button
                      className="search-back btn-icon toggle-search active"
                      onClick={() => {
                        setSearchText("");
                        toggle();
                      }}
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                    <input
                      type="text"
                      className="border-transparent form-focus-none form-control"
                      placeholder="Search by user or email"
                      value={onSearchText}
                      onChange={(e) => onFilterChange(e)}
                    />
                    <Button className="search-submit btn-icon">
                      <Icon name="search"></Icon>
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            {communityData?.loading ? (
              <div
                style={{
                  height: "200px",
                  width: "100%",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <Spinner type="grow" color="dark" />
              </div>
            ) : communityData?.success && communityData?.data?.length ? (
              <DataTableBody>
                <DataTableHead>
                  {/* Input:Checkbox */}
                  <DataTableRow className="nk-tb-col-check">
                    <div className="custom-control custom-control-sm custom-checkbox notext">
                      <input
                        type="checkbox"
                        className="custom-control-input form-control"
                        id={"uid_1"}
                        checked={communityData?.data
                          ?.map((item) => item._id)
                          .every((item) => selectedData.includes(item))}
                        onChange={(e) => selectorCheck(e)}
                      />
                      <label className="custom-control-label" htmlFor="uid_1"></label>
                    </div>
                  </DataTableRow>

                  {/* Name */}
                  <DataTableRow>
                    <span
                      onClick={() => {
                        setSort(sort === "asc" ? "desc" : sort === "desc" ? "asc" : "desc");
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Name
                      <Icon name={sort === "asc" ? "sort-up-fill" : sort === "desc" ? "sort-down-fill" : "sort-v"} />
                    </span>
                  </DataTableRow>

                  {/* Developments */}
                  <DataTableRow>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#5d5d5d",
                        fontWeight: "600",
                      }}
                    >
                      Developments
                    </span>
                  </DataTableRow>

                  {/* Home Type */}
                  <DataTableRow>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#5d5d5d",
                        fontWeight: "600",
                      }}
                    >
                      Home Type
                    </span>
                  </DataTableRow>

                  {/* Units/Floors */}
                  <DataTableRow>
                    <span style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}>
                      Units/Floors
                    </span>
                  </DataTableRow>

                  {/* Status */}
                  <DataTableRow>
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#5d5d5d",
                        fontWeight: "600",
                      }}
                    >
                      Status
                    </span>
                  </DataTableRow>

                  {/* Created By */}
                  <DataTableRow>
                    <span style={{ fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}>Created By</span>
                  </DataTableRow>

                  {/* Created On */}
                  <DataTableRow>
                    <span
                      onClick={() => {
                        setSort(sort === "recently-added" ? "oldest" : sort === "oldest" ? "recently-added" : "oldest");
                      }}
                      style={{ cursor: "pointer", fontSize: "14px", color: "#5d5d5d", fontWeight: "600" }}
                    >
                      Created On
                      <Icon
                        name={
                          sort === "recently-added" ? "sort-up-fill" : sort === "oldest" ? "sort-down-fill" : "sort-v"
                        }
                      />
                    </span>
                  </DataTableRow>

                  {/* Action Icon */}
                  <DataTableRow className="nk-tb-col-tools"></DataTableRow>
                </DataTableHead>

                {communityData?.data?.length
                  ? communityData?.data?.map((item) => {
                      return (
                        <DataTableItem key={item._id}>
                          {/* Input: Checkbox */}
                          <DataTableRow className="nk-tb-col-check">
                            <div className="custom-control custom-control-sm custom-checkbox notext">
                              <input
                                type="checkbox"
                                className="custom-control-input form-control"
                                id={item._id + "uid1"}
                                key={Math.random()}
                                checked={selectedData.includes(item._id)}
                                onChange={(e) => onSelectChange(e, item._id)}
                              />
                              <label className="custom-control-label" htmlFor={item._id + "uid1"}></label>
                            </div>
                          </DataTableRow>

                          {/* Name */}
                          <DataTableRow>
                            <div className="tb-product lazy-image" style={{ display: "flex", alignItems: "center" }}>
                              <div style={{ marginRight: "10px" }}>
                                <LazyLoadImage
                                  src={
                                    item?.images?.length
                                      ? `${process.env.REACT_APP_IMGURL}${item.images?.[0]}`
                                      : PlaceholderImg
                                  }
                                  alt="development_image"
                                  effect="blur"
                                  className="thumb"
                                  placeholderSrc={PlaceholderImg}
                                  style={{
                                    width: "105px",
                                    height: "67.5px",
                                    borderRadius: "4px",
                                    objectFit: "contain",
                                    border: "1px solid #cecece",
                                    background: "#ededed",
                                  }}
                                />
                              </div>
                              <div style={{ display: "flex", flexDirection: "column", fontSize: "12px" }}>
                                <div
                                  className="title"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px",
                                    padding: "0",
                                    margin: "0",
                                  }}
                                >
                                  <span>{item?.name}</span>
                                  <a
                                    href={`${process.env.REACT_APP_USER_WEB_URL}master-community/${item?.slug}`}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <ImNewTab style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px" }} />
                                  </a>
                                </div>
                                <span style={{}} className="sub-title">
                                  {item?.address?.firstLine}
                                </span>
                                <span style={{}} className="sub-title">
                                  {item?.address?.neighbourhood?.name}
                                </span>
                              </div>
                            </div>
                          </DataTableRow>

                          {/* Developments */}
                          <DataTableRow>
                            <div className="tb-sub">
                              {item?.developments?.map((li) => (
                                <div key={li?._id}>
                                  <a
                                    href={`${process.env.REACT_APP_USER_WEB_URL}development/${li?.slug}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: "#00aeff" }}
                                  >
                                    {li?.name}
                                  </a>
                                </div>
                              ))}
                            </div>
                          </DataTableRow>

                          {/* Home Type */}
                          <DataTableRow>
                            <span className="tb-sub">{item?.homeTypes?.map((li) => li?.name)?.join(", ")}</span>
                          </DataTableRow>

                          {/* Units/Floors */}
                          <DataTableRow>
                            {item?.units || item?.stories ? (
                              <span className="tb-sub">
                                {item?.units ? item?.units : 0}/{item?.stories ? item?.stories : 0}
                              </span>
                            ) : null}
                          </DataTableRow>

                          {/* Status */}
                          <DataTableRow>
                            <p
                              className="tb-sub"
                              style={{
                                color: item?.isDeleted
                                  ? "#FF2A04"
                                  : item?.status === "active"
                                  ? "#00E200"
                                  : item?.status === "sold"
                                  ? "#FF2A04"
                                  : item?.status === "pending"
                                  ? "#FFAF3D"
                                  : item?.status === "draft"
                                  ? "#7B8089"
                                  : item?.status === "on hold"
                                  ? "#285766"
                                  : "",
                                display: "flex",
                                alignItems: "center",
                                gap: "0",
                                padding: "0",
                                margin: "0",
                                textTransform: "capitalize",
                              }}
                            >
                              <span>{item?.isDeleted ? "Archived" : item?.status}</span>
                            </p>
                          </DataTableRow>

                          {/* Created By */}
                          <DataTableRow>
                            {item?.company?.admin?.admin ? (
                              <span className="tb-sub">
                                {`${item?.company?.admin?.admin?.firstName} ${item?.company?.admin?.admin?.lastName}`}
                              </span>
                            ) : (
                              ""
                            )}
                          </DataTableRow>

                          {/* Created On */}
                          <DataTableRow>
                            <span className="tb-sub">{moment(item?.createdAt).format("DD/MM/YYYY")}</span>
                          </DataTableRow>

                          {/* Icon: Options */}
                          <DataTableRow className="nk-tb-col-tools">
                            <ul className="nk-tb-actions gx-1 my-n1">
                              <li className="mr-n1">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    href="#more"
                                    onClick={(ev) => ev.preventDefault()}
                                    className="dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu right>
                                    <ul className="link-list-opt no-bdr">
                                      {(typeof status === "object" && status?.value === "archive") ||
                                      status === "archive" ? (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#view"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              handleRestore(item);
                                            }}
                                            disabled={permission && !permission?.edit}
                                          >
                                            {/* <Icon name="archived-fill"></Icon> */}
                                            <LuArchiveRestore
                                              style={{
                                                fontSize: "18px",
                                                marginRight: "15px",
                                                color: "#526484",
                                              }}
                                            />
                                            <span>Restore</span>
                                          </DropdownItem>
                                        </li>
                                      ) : (
                                        <>
                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#edit"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                navigate(`/master-community/edit/${item?._id}`);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="edit"></Icon>
                                              <span>Edit this Master Community</span>
                                            </DropdownItem>
                                          </li>

                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#view"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleActiveCommunity(item);
                                              }}
                                              disabled={permission && !permission?.edit}
                                            >
                                              <Icon name="eye"></Icon>
                                              <span>
                                                {item?.status === "active" ? "Put On Hold" : "Make It Active"}
                                              </span>
                                            </DropdownItem>
                                          </li>

                                          <li>
                                            <DropdownItem
                                              tag="a"
                                              href="#view"
                                              onClick={(ev) => {
                                                ev.preventDefault();
                                                handleArchive(item);
                                              }}
                                              disabled={permission && !permission?.archive}
                                            >
                                              <Icon name="archived-fill"></Icon>
                                              <span>Archive</span>
                                            </DropdownItem>
                                          </li>
                                        </>
                                      )}

                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#view"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            handleDelete(item);
                                          }}
                                          disabled={permission && !permission?.delete}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Delete Permanently</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })
                  : null}
              </DataTableBody>
            ) : communityData?.success && !communityData?.data?.length ? (
              <div
                className="text-center"
                style={{
                  padding: "20px",
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
              >
                <span className="text-silent">No Master Communities found</span>
              </div>
            ) : communityData?.error ? (
              <ErrorComponent error={communityData?.error} />
            ) : null}

            <div className="card-inner p-0">
              {communityData?.success && communityData?.data?.length ? (
                <DotPagination
                  itemPerPage={communityData?.total?.items_per_page}
                  totalItems={communityData?.total?.total}
                  paginate={paginate}
                  currentPage={currentPage}
                  siblingCount={2}
                  screenWidth={screenWidth}
                />
              ) : null}
            </div>
          </DataTable>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default Community;
